import React from 'react';

const iconsSvg = {
    close: (<div>
<svg width="14px" height="14px" viewBox="0 0 14 14" version="1.1">
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="1_Desktop_source" transform="translate(-697.000000, -179.000000)" fill="#929BAA" fillRule="nonzero">
            <g id="close" transform="translate(696.000000, 178.000000)">
                <g id="menu-(2)">
                    <path d="M17,7.5 C17,7.2 16.7,7 16.25,7 L-0.25,7 C-0.7,7 -1,7.2 -1,7.5 L-1,8.5 C-1,8.8 -0.7,9 -0.25,9 L16.25,9 C16.7,9 17,8.8 17,8.5 L17,7.5 Z" id="Shape" transform="translate(8.000000, 8.000000) rotate(-45.000000) translate(-8.000000, -8.000000) "></path>
                    <path d="M17,7.5 C17,7.2 16.7,7 16.25,7 L-0.25,7 C-0.7,7 -1,7.2 -1,7.5 L-1,8.5 C-1,8.8 -0.7,9 -0.25,9 L16.25,9 C16.7,9 17,8.8 17,8.5 L17,7.5 Z" id="Shape" transform="translate(8.000000, 8.000000) rotate(45.000000) translate(-8.000000, -8.000000) "></path>
                </g>
            </g>
        </g>
    </g>
</svg></div>),
    gamburger: (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="none" d="M0 0h24v24H0V0z"/><path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"/></svg> ),
    basket: (
        <svg width="16px" height="14px" viewBox="0 0 16 14">
            <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="Guide" transform="translate(-343.000000, -949.000000)">
                    <g id="case" transform="translate(341.000000, 946.000000)">
                        <path d="M3.5,17 C2.67157288,17 2,16.3284271 2,15.5 L2,7.5039447 C2,6.67551758 2.67157288,6.0039447 3.5,6.0039447 L7,6.0039447 L7,4 C7,3.44771525 7.44771525,3 8,3 L12,3 C12.5522847,3 13,3.44771525 13,4 L13,6 L16.5,6 C17.3284271,6 18,6.67157288 18,7.5 L18,15.5 C18,16.3284271 17.3284271,17 16.5,17 L3.5,17 Z M8.5,4.5 L8.5,6 L11.5,6 L11.5,4.5 L8.5,4.5 Z" id="Combined-Shape" fill="#929BAA"></path>
                        <rect id="Rectangle-Copy-3" x="0" y="0" width="20" height="20"></rect>
                    </g>
                </g>
            </g>
        </svg>
    ),
    person: (
        <svg width="16px" height="14px" viewBox="0 0 16 14">
            <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="Guide" transform="translate(-343.000000, -949.000000)">
                    <g id="case" transform="translate(341.000000, 946.000000)">
                        <path d="M3.5,17 C2.67157288,17 2,16.3284271 2,15.5 L2,7.5039447 C2,6.67551758 2.67157288,6.0039447 3.5,6.0039447 L7,6.0039447 L7,4 C7,3.44771525 7.44771525,3 8,3 L12,3 C12.5522847,3 13,3.44771525 13,4 L13,6 L16.5,6 C17.3284271,6 18,6.67157288 18,7.5 L18,15.5 C18,16.3284271 17.3284271,17 16.5,17 L3.5,17 Z M8.5,4.5 L8.5,6 L11.5,6 L11.5,4.5 L8.5,4.5 Z" id="Combined-Shape" fill="#929BAA"></path>
                        <rect id="Rectangle-Copy-3" x="0" y="0" width="20" height="20"></rect>
                    </g>
                </g>
            </g>
        </svg>
    ),
    mail: (
        <svg width="24" height="24" viewBox="0 0 24 24"><path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/><path d="M0 0h24v24H0z" fill="none"/></svg>
    ),
    ring: (
        <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M12 22c1.1 0 2-.9 2-2h-4c0 1.1.89 2 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z"/></svg>
    ),
    guard: (
        <svg width="24" height="24" viewBox="0 0 24 24"><path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm0 10.99h7c-.53 4.12-3.28 7.79-7 8.94V12H5V6.3l7-3.11v8.8z"/><path d="M0 0h24v24H0z" fill="none"/></svg>
    ),
    done: (
        <svg width="24" height="24" viewBox="0 0 24 24"><path fill="none" d="M0 0h24v24H0z"/><path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z"/></svg>
    ),
    back: (
        <svg width="24" height="24" viewBox="0 0 24 24"><path d="M0 0h24v24H0z" fill="none"/><path d="M21 11H6.83l3.58-3.59L9 6l-6 6 6 6 1.41-1.41L6.83 13H21z"/></svg>
    ),
    search: (
        <svg width="24" height="24" viewBox="0 0 24 24"><path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/><path d="M0 0h24v24H0z" fill="none"/></svg>
    ),
    offer: (
      <svg width="14px" height="12px" viewBox="0 0 14 12">
        <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g id="2_Desktop_2" transform="translate(-1256.000000, -428.000000)" fill="#1D1F46">
            <g id="Group-4-Copy-3" transform="translate(1253.000000, 424.000000)">
              <path d="M17,9.625 L11.5677083,15.2125 L11.5677083,11.95 C9.62325417,11.9249999 7.95226393,12.2499966 6.5546875,12.925 C5.15711107,13.6000034 3.97222708,14.6249931 3,16 C3.36458516,13.9499898 4.20919477,12.0875084 5.53385417,10.4125 C6.85851357,8.73749163 8.86977818,7.67500225 11.5677083,7.225 L11.5677083,4 L17,9.625 Z" id="send-copy-2"></path>
            </g>
          </g>
        </g>
      </svg>
    ),
    document: (
      <svg version="1.1" width="24" height="24" viewBox="0 0 24 24"><path d="M15,7H20.5L15,1.5V7M8,0H16L22,6V18A2,2 0 0,1 20,20H8C6.89,20 6,19.1 6,18V2A2,2 0 0,1 8,0M4,4V22H20V24H4A2,2 0 0,1 2,22V4H4Z" /></svg>
    ),
};

export default iconsSvg;



// WEBPACK FOOTER //
// ./src/assets/img/svgLib/iconsSvg.js